import React, { useEffect, useState } from "react";
import { Lock, LockOpen } from "lucide-react";
import { getClosedMonths, setMonthClosed } from "../api";

export const MonthLock = ({ month, label }) => {
  const [closed, setClosed] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { getClosedMonths().then(setClosed).catch(() => {}); }, []);
  const isClosed = closed.includes(month);

  const toggle = async () => {
    const msg = isClosed
      ? `${label} wieder öffnen? Putzfrauen können dann wieder Stunden eintragen.`
      : `${label} abschliessen? Putzfrauen können danach keine Stunden mehr in diesem Monat eintragen. Sie selbst können weiterhin korrigieren.`;
    if (!window.confirm(msg)) return;
    setBusy(true);
    try { setClosed(await setMonthClosed(month, !isClosed)); }
    catch (e) { alert("Fehler: " + (e.response?.data?.detail || e.message)); }
    setBusy(false);
  };

  return isClosed ? (
    <button data-testid="rapport-month-reopen" disabled={busy} onClick={toggle} title="Monat wieder öffnen"
      className="inline-flex items-center gap-1.5 px-3 h-10 rounded-xl bg-slate-800 text-white text-sm font-semibold hover:bg-slate-700 disabled:opacity-50">
      <Lock className="w-4 h-4" /> Abgeschlossen <span className="text-slate-300 font-normal">· öffnen</span>
    </button>
  ) : (
    <button data-testid="rapport-month-close" disabled={busy} onClick={toggle}
      className="inline-flex items-center gap-1.5 px-3 h-10 rounded-xl border border-slate-300 bg-white text-slate-700 text-sm font-semibold hover:bg-slate-50 disabled:opacity-50">
      <LockOpen className="w-4 h-4" /> Monat abschliessen
    </button>
  );
};
